import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { getIsMobile, getIsWhitelabel } from 'src/store/view/selectors';
import {
  getCashbackLabel,
  getCashbackLabelBackgroundColor,
  getCashbackLabelTextColor,
  getCashbackTooltip,
  getActivateCashbackForPartner,
  getCashbackIconWebp,
  getCashbackIconPng,
} from 'src/store/cashback/selectors';
import {
  getOffersForCurrentDateWithAllHotelFilters,
  getSearcherTouristsCount,
  getIsSetDefaultFilters,
} from '../../store/selectors/searcher';
import { openOfferAction } from '../../store/actions/offer';
import { openFiltersListAction } from '../../store/actions/searcher';

import { HotelRatesResults } from './HotelRatesResults';
import { openAboutRoomPopup } from '../../../../store/roomPopup/slice';
import { getSearchedNights } from '../../store/selectors/common';
import { getHotelFacilitiesRoomForSearcher } from '../../store/hotel';

const mapStateToProps = (state) => ({
  items: getOffersForCurrentDateWithAllHotelFilters(state),
  activateCashbackForPartner: getActivateCashbackForPartner(state),
  searchedNights: getSearchedNights(state),
  hotelFacilities: getHotelFacilitiesRoomForSearcher(state),
  tourists: getSearcherTouristsCount(state),
  isSetDefaultFilters: getIsSetDefaultFilters(state),
  isMobile: getIsMobile(state),
  labelColor: getCashbackLabelBackgroundColor(state),
  textColor: getCashbackLabelTextColor(state),
  cashbackTooltipText: getCashbackTooltip(state),
  cashbackLabel: getCashbackLabel(state),
  cashbackIconWebp: getCashbackIconWebp(state),
  cashbackIconPng: getCashbackIconPng(state),
  isWhiteLabel: getIsWhitelabel(state),
});

const mapDispatchToProps = (dispatch) => ({
  onOfferClicked: (offer) => dispatch(openOfferAction(offer)),
  onClickOpenFilters: () => dispatch(openFiltersListAction(true)),
  onLeaveNotFullOffersSpan: () => dispatch(openFiltersListAction(false)),
  onClickGallery: (id) => dispatch(openAboutRoomPopup(id)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(HotelRatesResults);
